'use strict';

// 구 편집기(radio/checkbox) 저장 전 선택지 검사 — 순수 함수(Vue 의존 없음, tests/ 에서 node --test 로 검증)

const isBlank = (v) => v == null || String(v).trim() === '';

/** 선택지 목록 하나의 첫 문제. where 는 문장 앞머리('' 면 최상위) */
function listProblem(structure, where) {
    if (!structure.length) return `${where}선택지를 하나 이상 추가해 주세요.`;
    // Map — 'constructor' 같은 값도 일반 문자열로 다룬다
    const seen = new Map();
    for (let i = 0; i < structure.length; i++) {
        const item = structure[i] || {};
        const no = i + 1;
        if (isBlank(item.text) || isBlank(item.value)) return `${where}${no}번 선택지의 text 와 value 를 입력해 주세요.`;
        const key = String(item.value);
        if (seen.has(key)) return `${where}${seen.get(key)}번과 ${no}번 선택지의 value 가 '${key}' 로 같습니다. 응답을 구분할 수 있게 바꿔 주세요.`;
        seen.set(key, no);
        const elements = Array.isArray(item.element_contents) ? item.element_contents : [];
        for (let j = 0; j < elements.length; j++) {
            const el = elements[j];
            if (!el || isBlank(el.type)) return `${where}${no}번 선택지의 세부요소 유형을 고르거나 세부요소를 지워 주세요.`;
            // 세부요소가 다시 선택형이면 그 안의 선택지도 같은 규칙
            if (['radio', 'checkbox'].includes(el.type) && Array.isArray(el.structure)) {
                const inner = listProblem(el.structure, `${where}${no}번 선택지의 세부요소 ${j + 1}: `);
                if (inner) return inner;
            }
        }
    }
    return '';
}

/** 첫 번째 문제의 사유 문장. 문제 없으면 '' */
function choiceProblem({ needs_label = false, sub_label = '', structure } = {}) {
    if (needs_label && isBlank(sub_label)) return 'Sub label 을 입력해 주세요.';
    // 모양을 모르는 구조는 막지 않는다
    if (!Array.isArray(structure)) return '';
    return listProblem(structure, '');
}

module.exports = { choiceProblem };
